/**
 * When a search includes a space character, you can either use:
 * 1. An escaped space `a\ b`
 * 2. Quotes `"a b"`
 *
 * If you want to use wildcards you cannot use quotes
 * This query `"*a b*"` would look for a literal `*`
 * The proper way would be to escape the space character `*a\ b*`, here the `*` characters will be used as a wildcard
 *
 * Using the escaped space has its own drawbacks though
 * When searching on tokenized fields the space splits the query making two token: `a` and `b`
 * Which means anything with `a` would match, even without a `b` present
 *
 * Neither of these options can be used all the time, that's why you can pass how the spaces should be handled
 */
export enum QueryHandleQuotes {
    // Use when you need wildcards, but don't use on tokenized fields
    Escape = 'Escape',
    // Use when you need to search on exact phrases on tokenized fields
    UseQuotes = 'UseQuotes'
}
